module.exports = __webpack_public_path__ + "img/cjcl9.3d9b1148.png";